import {css} from 'lit';

// Réplica fiel del clam-main-styles legacy (Polymer app-header), adaptada a Lit.
// app-header fijo con condensing: up-toolbar (blanco, 150px) colapsa al scroll;
// main-toolbar (gris #6d6e71) transiciona a verde #55aa00 (rear layer).

export const ClamMainStyles = css`
    :host {
        z-index: 1;
        display: block;
        width: 100%;
        background: #fff;
        color: #424244;
        font-family: 'Avenir', 'Quattrocento Sans', 'Helvetica Neue', Arial, sans-serif;
    }
    * {
        box-sizing: border-box;
    }
    a {
        text-decoration: none;
        color: inherit;
    }

    /* ===== Fixed header (réplica app-header) ===== */
    .app-header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 100;
        background-color: #6d6e71;
        transition: background-color 0.6s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
    :host([data-condensed]) .app-header,
    .app-header.condensed {
        background-color: #55aa00;
    }

    /* up-toolbar: barra social blanca, colapsa al condensar */
    #up-toolbar {
        height: 150px;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-template-rows: auto;
        justify-items: center;
        align-content: center;
        background-color: #fff;
        overflow: hidden;
        transition: height 0.6s ease, opacity 0.6s ease;
    }
    .app-header.condensed #up-toolbar {
        height: 0;
        opacity: 0;
    }
    .up-toolbar-content {
        display: grid;
        grid-template-columns: 1fr;
        justify-items: center;
        align-content: center;
        text-align: center;
        color: #747474;
        font-size: 14px;
        transition: transform 0.3s ease;
        text-decoration: none;
    }
    .up-toolbar-content:hover {
        transform: scale(1.04);
    }
    .up-toolbar-content img {
        width: 25px;
    }
    .up-toolbar-content p {
        margin: 4px 0 0;
    }
    .up-toolbar-content span {
        font-weight: bold;
        color: #5aaa2f;
    }
    .up-toolbar-logo {
        width: 120px;
        transition: transform 1s ease;
    }
    .up-toolbar-logo:hover {
        transform: scale(1.04);
    }

    /* main-toolbar: nav */
    #main-toolbar {
        height: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;
        min-height: 70px;
    }
    .nav-title {
        display: none;
        justify-content: flex-start;
        align-items: center;
        color: #fff;
        font-size: 20px;
    }
    .app-header.condensed .nav-title {
        display: flex;
    }
    .nav-title img {
        width: 50px;
        padding: 15px 30px 15px 0;
    }
    .nav-title p {
        min-width: 460px;
        margin: 0;
        line-height: 1.2;
    }

    /* nav (réplica paper-tabs + vaadin-menu-bar) */
    nav.desktop-nav {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 4px;
        flex-wrap: nowrap;
    }
    nav.desktop-nav > a,
    .nav-trigger {
        color: #fff;
        font-weight: bold;
        font-size: 12px;
        font-family: 'Avenir', sans-serif;
        line-height: 50px;
        height: 50px;
        text-align: center;
        padding: 0 14px;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        white-space: nowrap;
        background-color: transparent;
        border: none;
        border-radius: 30px;
        transition: background-color 0.2s ease;
    }
    nav.desktop-nav > a:hover,
    .nav-trigger:hover {
        background-color: rgba(0, 0, 0, 0.2);
    }
    .nav-group {
        position: relative;
        display: inline-flex;
    }
    .nav-trigger .caret {
        font-size: 10px;
        line-height: 1;
    }
    .nav-group.open .nav-trigger {
        background-color: rgba(0, 0, 0, 0.25);
    }
    .nav-group-items {
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        min-width: 190px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
        border-radius: 10px;
        padding: 6px;
        display: flex;
        flex-direction: column;
        gap: 2px;
        z-index: 200;
    }
    .nav-group-items a {
        color: #1d1d1d;
        font-size: 12px;
        font-weight: bold;
        line-height: 24px;
        height: 32px;
        padding: 4px 12px;
        border-radius: 20px;
        text-align: center;
        display: block;
    }
    .nav-group-items a:hover {
        background-color: rgba(82, 82, 82, 0.33);
    }
    nav.desktop-nav .plataforma-clam-btn,
    .plataforma-clam-btn {
        background-color: #4caf50;
        color: #fff !important;
        max-width: 110px;
        border-radius: 20px;
        line-height: 31px;
        height: 31px;
        align-self: center;
        padding: 0 18px;
        border: none;
        transition: all 0.2s ease;
    }
    nav.desktop-nav .plataforma-clam-btn:hover {
        background-color: #56b14a;
        border-radius: 4px;
    }
    nav.desktop-nav > a.active,
    nav.desktop-nav .nav-trigger.contains-active {
        background-color: rgba(0, 0, 0, 0.28);
    }
    .nav-group-items a.active {
        background-color: rgba(90, 157, 30, 0.14);
        color: #4a7c10;
    }
    .menu-btn {
        display: none;
        background: transparent;
        border: none;
        color: #fff;
        font-size: 26px;
        cursor: pointer;
        padding: 8px;
    }

    /* content offset — header fijo mide ~220px */
    .header-spacer {
        height: 220px;
    }
    main {
        display: flow-root;
    }
    main > * {
        display: flow-root;
    }

    /* mobile drawer */
    .drawer-scrim {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.45);
        z-index: 499;
        animation: scrimIn 0.2s ease;
    }
    @keyframes scrimIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
    .mobile-drawer {
        position: fixed;
        top: 0;
        left: 0;
        width: 300px;
        max-width: 85vw;
        height: 100vh;
        height: 100dvh;
        background: #ffffff;
        box-shadow: 4px 0 28px rgba(0, 0, 0, 0.22);
        z-index: 500;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        animation: drawerIn 0.22s ease;
    }
    @keyframes drawerIn {
        from { transform: translateX(-100%); }
        to { transform: none; }
    }
    .drawer-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 18px;
        border-bottom: 1px solid #ececec;
        background: #fafafa;
        flex-shrink: 0;
    }
    .drawer-header img {
        width: 110px;
    }
    .drawer-header button {
        background: none;
        border: none;
        font-size: 22px;
        cursor: pointer;
        color: #6d6e71;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.15s ease, color 0.15s ease;
    }
    .drawer-header button:hover {
        background: #ececec;
        color: #333;
    }
    .drawer-nav {
        display: flex;
        flex-direction: column;
        gap: 2px;
        padding: 12px;
        flex: 1;
    }
    .drawer-nav > a,
    .drawer-nav .nav-trigger {
        color: #2b2b2b !important;
        background-color: transparent !important;
        font-size: 15px;
        font-weight: 600;
        font-family: 'Avenir', sans-serif;
        line-height: 1.2;
        height: auto;
        padding: 14px 16px;
        border-radius: 10px;
        text-align: left;
        width: 100%;
        justify-content: space-between;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        transition: background-color 0.15s ease, color 0.15s ease;
    }
    .drawer-nav > a:hover,
    .drawer-nav .nav-trigger:hover {
        background-color: #f1f8e9 !important;
        color: #4a7c10 !important;
    }
    .drawer-nav > a.active,
    .drawer-nav .nav-trigger.contains-active {
        background-color: #5a9d1e !important;
        color: #fff !important;
    }
    .drawer-nav .nav-trigger .caret {
        color: inherit;
        font-size: 12px;
        transition: transform 0.2s ease;
    }
    .drawer-nav .nav-group.open > .nav-trigger {
        background-color: #f1f8e9 !important;
        color: #4a7c10 !important;
    }
    .drawer-nav .nav-group.open > .nav-trigger .caret {
        transform: rotate(180deg);
    }
    .drawer-nav .nav-group-items {
        position: static;
        box-shadow: none;
        background: transparent;
        padding: 2px 0 6px 0;
        margin-left: 14px;
        border-left: 2px solid #e3efce;
        min-width: 0;
        border-radius: 0;
        gap: 0;
        transform: none;
    }
    .drawer-nav .nav-group-items a {
        color: #555;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.2;
        height: auto;
        padding: 11px 14px;
        border-radius: 8px;
        text-align: left;
        display: block;
    }
    .drawer-nav .nav-group-items a:hover {
        background-color: #f1f8e9;
        color: #4a7c10;
    }
    .drawer-nav .nav-group-items a.active {
        color: #5a9d1e;
        font-weight: 700;
        background-color: #eef6df;
    }
    .drawer-socio-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 14px 8px 4px;
        padding: 0 18px;
        min-height: 48px;
        background-color: #4caf50;
        color: #fff !important;
        border-radius: 24px;
        font-weight: 600;
        font-size: 15px;
        text-decoration: none;
        transition: background-color 0.2s ease;
    }
    .drawer-socio-btn:hover {
        background-color: #56b14a;
    }

    /* informative content (address + map) — réplica legacy */
    .informative-content {
        display: grid;
        grid-template-columns: 30% 70%;
        gap: 20px;
        padding: 50px 0;
        justify-items: center;
        align-items: center;
        height: 700px;
    }
    .address {
        text-align: left;
        padding: 100px;
        font-size: 20px;
        font-weight: normal;
        color: #606060;
    }
    .address span {
        font-weight: bold;
        font-size: 21px;
    }
    .address p {
        margin-top: 30px;
        margin-left: 6%;
    }
    .address h1 {
        margin-left: 10%;
    }
    #map {
        width: 90%;
        height: 600px;
        z-index: 0;
        border-radius: 12px;
        overflow: hidden;
    }

    /* responsive */
    @media (max-width: 1150px) {
        .up-toolbar-content {
            font-size: 10px;
        }
        .up-toolbar-logo {
            width: 100px;
        }
    }
    @media (max-width: 1024px) {
        nav.desktop-nav {
            display: none;
        }
        .menu-btn {
            display: inline-block;
        }
        .nav-title p {
            display: none;
        }
    }
    @media (max-width: 700px) {
        .header-spacer {
            height: 70px;
        }
        #up-toolbar {
            display: none;
        }
        .informative-content {
            grid-template-columns: 1fr;
            height: 100%;
        }
        .address {
            text-align: center;
            padding: 100px 5%;
        }
        #map {
            height: 500px;
            width: 90%;
        }
    }
    @media (max-width: 400px) {
        #map {
            width: 90%;
        }
        .address {
            font-size: 16px;
            width: auto;
        }
    }
`;
